<template>
  <div class="GraphsPage">
    <h3>Buurt informatie over {{ activeNeighborhoodName }}</h3>
    <p class="text-red">
      <FontAwesomeIcon :icon="['fas', 'info-circle']" class="mr-2" />
      Let op, deze cijfers zijn <span >niet</span> beinvloed door de barcode selectie
    </p>
    <div class="d-flex mt-3 flex-wrap">
      <div class="GraphsPage__table mr-4 mb-3">
        <h3>Socio-economische cijfers</h3>
        <b-table-simple caption-top >
          <b-tbody>
            <b-tr>
              <b-td>Gemiddeld inkomen (2017)</b-td>
              <b-td colspan="2">{{ numberWithDots(getActiveNeighborhoodGeoData.gem_inkomen) }} Euro</b-td>
            </b-tr>
            <b-tr>
              <b-td>Aantal huishoudens (2019)</b-td>
              <b-td colspan="2">{{ numberWithDots(getActiveNeighborhoodGeoData.huishoudens) }}</b-td>
            </b-tr>
            <b-tr>
              <b-td>Aantal inwoners (2019)</b-td>
              <b-td colspan="2">{{ numberWithDots(getActiveNeighborhoodGeoData.inwoners.totaal) }}</b-td>
            </b-tr>
            <b-tr>
              <b-td class="pl-5">Inwoners t/m 25 jaar (2019)</b-td>
              <b-td>{{ getActiveNeighborhoodGeoData.inwoners['0-25'] }}%</b-td>
              <b-td>{{ numberWithDots((getActiveNeighborhoodGeoData.inwoners.totaal * getActiveNeighborhoodGeoData.inwoners['0-25'] / 100).toFixed(0)) }}</b-td>
            </b-tr>
            <b-tr>
              <b-td class="pl-5">Inwoners 65+ jaar (2019)</b-td>
              <b-td>{{ getActiveNeighborhoodGeoData.inwoners['65+'] }}% </b-td>
              <b-td>{{ numberWithDots((getActiveNeighborhoodGeoData.inwoners.totaal * getActiveNeighborhoodGeoData.inwoners['65+'] / 100).toFixed(0)) }}</b-td>
            </b-tr>
            <b-tr>
              <b-td class="pl-5">Niet westerse migranten (2019)</b-td>
              <b-td>{{ getActiveNeighborhoodGeoData.inwoners.allochtonen }}%</b-td>
              <b-td>{{ numberWithDots((getActiveNeighborhoodGeoData.inwoners.totaal * getActiveNeighborhoodGeoData.inwoners.allochtonen / 100).toFixed(0)) }}</b-td>
            </b-tr>
            <b-tr>
              <b-td class="pl-5">Inwoners met een uitkering (2017)</b-td>
              <b-td>{{ getActiveNeighborhoodGeoData.inwoners.uitkering }}%</b-td>
              <b-td>{{ numberWithDots((getActiveNeighborhoodGeoData.inwoners.totaal * getActiveNeighborhoodGeoData.inwoners.uitkering / 100).toFixed(0)) }}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
      <SimpleBarChart class="mb-3" :rows="functions" :limit="10" label="Gebouwfuncties" color="#7a99ac" />
    
    </div>
  </div>
</template>

<script>

import SimpleBarChart from '@/components/SimpleBarChart'

import { mapGetters } from 'vuex'

import { numberWithDots } from '@/helpers/number'

export default {
  name: 'GraphsPage',
  components: { 
    SimpleBarChart
  },
  computed: {
    ...mapGetters('filters', [
      'getActiveNeighborhoodInfo'
    ]),
    ...mapGetters('geodata', [
      'getActiveNeighborhoodGeoData'
    ]),
    activeNeighborhoodName() {
      return this.getActiveNeighborhoodInfo.label
    },
    functions() {
      return Object.keys(this.getActiveNeighborhoodGeoData.functies).map(label => {
        return {
          label,
          value: this.getActiveNeighborhoodGeoData.functies[label],
          filter: 0,
          disabled: false
        }
      })
    }
  },
  methods: {
    numberWithDots
  }
}
</script>

<style lang="scss"> 
.GraphsPage {
  &__table {
    width: 500px;
    background: white;
    padding: 20px;

    h3 {
      font-size: 1.2em;
      font-weight: 700;
      margin-bottom: 20px;
      padding-left: 0.75rem;
      line-height: 1.5;
    }
    tr {
      display: flex;
      width: 100%;
      justify-content: space-between;
    }
    td {
      max-height: 40px;
      height: 40px;
      display: flex;
      align-items: center;
    }
    tr td:first-child {
      font-weight: 600;
      flex-grow: 1;
    }
  }
  .SimpleBarChart {
    min-width: 500px;
    width: 100%;
    max-width: 750px;
  }
}
</style>